import EventActionProto from './event-action-proto';

// use it kak ignore event

export default class SessionEventDoNothing extends EventActionProto {

    public method     : string
    public fromSID    : string

    constructor(sessionEvent:any) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
    }
};